<template>
  <a-row>
    <a-tabs defaultActiveKey="1">
      <a-tab-pane tab="CUENTAS CONTABLE" key="1">
        <g-master name="fmo_items_taxes"
                  @params="paramsTable"
                  :endpoint="master.endpoint"
                  :tableSetup="master.tableSetup"
                  :modalFieldsSetup="master.modalFieldsSetup"
                  modalWidth="90%"
        >
          <template slot="customButton">
            <g-btn-excel :endpoint="endpointExcel" :params="paramsExcel" :fileName="fileNameExcel"/>
          </template>
          <template slot="masterModal" slot-scope="{record}">
            <a-row :gutter="[16, 16]">
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Cuenta Contable')">
                  <a-input
                    v-decorator="['n1', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Descripcion')">
                  <a-input
                    v-decorator="['name', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Nivel')">
                  <a-input
                    v-decorator="['level', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Att1')">
                  <a-input
                    v-decorator="['att1', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Att2')">
                  <a-input
                    v-decorator="['att2', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Att3')">
                  <a-input
                    v-decorator="['att3', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Att4')">
                  <a-input
                    v-decorator="['att4', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Att5')">
                  <a-input
                    v-decorator="['att5', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Att6')">
                  <a-input
                    v-decorator="['att6', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
            </a-row>
          </template>
        </g-master>
      </a-tab-pane>
    </a-tabs>
  </a-row>
</template>

<script>
  export default {
    data () {
      return {
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          endpoint: 'chart_account',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Cuenta contable', dataIndex: 'n1', sorter: true},
              {title: 'Descripcion', dataIndex: 'name', sorter: true},
              {title: 'Nivel', dataIndex: 'level', sorter: true},
              {title: 'att1', dataIndex: 'att1', sorter: true},
              {title: 'att2', dataIndex: 'att2', sorter: true},
              {title: 'att3', dataIndex: 'att3', sorter: true},
              {title: 'att4', dataIndex: 'att4', sorter: true},
              {title: 'att5', dataIndex: 'att5', sorter: true},
              {title: 'att6', dataIndex: 'att6', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'n1'},
            {name: 'name'},
            {name: 'level'},
            {name: 'att1'},
            {name: 'att2'},
            {name: 'att3'},
            {name: 'att4'},
            {name: 'att5'},
            {name: 'att6'}
          ]
        },
        endpointExcel: 'chart_account_/downloadExcel',
        fileNameExcel: 'CuentasContables',
        paramsT: {}
      }
    },
    methods: {
      paramsTable (params) {
        this.paramsT = params
      }
    },
    computed: {
      paramsExcel () {
        return {...this.paramsT, columns: this.master.tableSetup.columns}
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Fmo/ChartAccount.vue